export const quote = {
  quoteStatus: [{
    value: 1, label: '有效'
  }, {
    value: 0, label: '无效'
  }],
  quoteYesOrNo: [{
    value: 1, label: '是'
  }, {
    value: 0, label: '否'
  }],
  quoteType: [{
    value: 1, label: '客户端出单'
  }, {
    value: 0, label: '直连保司API出单'
  }],
  priceConfigStatus: [{
    value: -1, label: '未配置'
  }, {
    value: 0, label: '暂存'
  }, {
    value: 1, label: '审核中'
  }, {
    value: 2, label: '审核通过'
  }, {
    value: 9, label: '审核不通过'
  }, {
    value: -9, label: '禁用'
  }],
  priceRiskStatus: [{
    label: '全部',
    value: ''
  }, {
    label: '锁定',
    value: 0
  }, {
    label: '正常',
    value: 1
  }]
}

export default {
  quote
}



// WEBPACK FOOTER //
// ./src/data/quote.js